module.exports = __webpack_public_path__ + "static/img/notext-startrip.800530f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-startrip.png
// module id = DvqY
// module chunks = 1